import { render, staticRenderFns } from "./demo9.vue?vue&type=template&id=6f52e83c&scoped=true&"
import script from "./demo9.vue?vue&type=script&lang=js&"
export * from "./demo9.vue?vue&type=script&lang=js&"
import style0 from "./demo9.vue?vue&type=style&index=0&id=6f52e83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52e83c",
  null
  
)

export default component.exports